/**
 * Replace // with <br>.
 */
export default (value: string) => (value ? value.split('\\').join('<br>') : '')
